import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs',
})
export class AbsPipe implements PipeTransform {
  transform(input: number) {
    if (isNaN(input) || input === 0) return '-';
    else return Math.abs(input);
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/abs/abs.ts